import { useState } from 'react';

const faqs = [
  {
    id: 1,
    question: 'Minimum sipariş miktarı nedir?',
    answer: 'Bioetiket olarak minimum sipariş konusunda esnek bir yaklaşım sunuyoruz. Dijital baskıda 100 adet, flekso baskıda ise 1.000 adetten başlayan siparişleri kabul ediyoruz. Küçük işletmeler için de çözümlerimiz mevcut, detaylı bilgi için bizimle iletişime geçebilirsiniz.'
  },
  {
    id: 2,
    question: 'Teslimat süresi ne kadar?',
    answer: 'Standart siparişlerinizde 3-5 iş günü içinde teslimat gerçekleştiriyoruz. Acil ihtiyaçlarınız için 24 saat içinde üretim ve kargo seçeneği sunuyoruz. Büyük hacimli siparişlerde süre değişebilir, size özel bir üretim planı hazırlarız.'
  },
  {
    id: 3,
    question: 'Hangi etiket malzemeleri ile çalışıyorsunuz?',
    answer: 'Kağıt, PP (polipropilen), PE (polietilen), PET, PVC, folyo, hologram ve özel kaplamalı malzemeler dahil geniş bir yelpaze sunuyoruz. Gıda, kozmetik, ilaç ve endüstriyel kullanıma uygun, su ve ısı dirençli seçeneklerimiz mevcuttur.'
  },
  {
    id: 4,
    question: 'Tasarım desteği sunuyor musunuz?',
    answer: 'Evet! Profesyonel grafik tasarım ekibimiz markanıza özel etiket tasarımları hazırlar. Hazır tasarımınız varsa AI, PDF, EPS veya yüksek çözünürlüklü PNG/JPEG formatlarında gönderebilirsiniz. Tasarım revizyonları ücretsizdir.'
  },
  {
    id: 5,
    question: 'Numune sipariş verebilir miyim?',
    answer: 'Kesinlikle! Ücretsiz numune hizmetimizden faydalanabilirsiniz. Ürününüze uygun malzeme ve baskı kalitesini görmek için numune talebinde bulunabilirsiniz. Numune siparişleri genellikle 1-2 iş günü içinde hazırlanır.'
  },
  {
    id: 6,
    question: 'Gıda ve ilaç sektörüne uygun sertifikalarınız var mı?',
    answer: 'Evet, gıda temasına uygun FDA onaylı malzemeler kullanıyoruz. İlaç sektörü için GMP (İyi Üretim Uygulamaları) standartlarına uygun üretim yapıyoruz. Tüm sertifikalarımız ve uygunluk belgelerimiz talep üzerine paylaşılır.'
  },
  {
    id: 7,
    question: 'Baskı renk seçenekleri nelerdir?',
    answer: 'CMYK 4 renk baskının yanı sıra 12 renge kadar Pantone renk eşleştirmesi yapabiliyoruz. Metalik, floresan ve özel efekt renkler de mevcuttur. Her siparişte renk tutarlılığı için kalibrasyonlu üretim yapılmaktadır.'
  },
  {
    id: 8,
    question: 'Kargo ve teslimat seçenekleri nelerdir?',
    answer: 'Türkiye\'nin her iline anlaşmalı kargo firmalarımız aracılığıyla hızlı ve güvenli teslimat sağlıyoruz. İstanbul içi siparişlerde kurye ile aynı gün teslimat seçeneği mevcuttur. Uluslararası gönderim için ayrıca bilgi alabilirsiniz.'
  }
];

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggle = (id: number) => {
    setOpenId(prev => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Sol: Başlık & Açıklama */}
          <div className="lg:sticky lg:top-32">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
              <span className="text-sm font-semibold tracking-widest text-gray-500 uppercase">
                Sıkça Sorulan Sorular
              </span>
              <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
            </div>

            <h2 className="text-5xl font-bold text-[#1A2332] leading-tight mb-4">
              Aklınızdaki
            </h2>
            <h2 className="text-5xl font-bold italic text-[#FF6B35] leading-tight mb-6">
              Soruları Yanıtlıyoruz
            </h2>

            <p className="text-base text-gray-600 leading-relaxed mb-8">
              Etiket baskı sürecinde en çok merak edilen konuları derledik. Cevabını bulamadığınız bir soru varsa bize doğrudan ulaşabilirsiniz.
            </p>

            <div className="bg-[#FAF8F5] rounded-2xl p-6 space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-full">
                  <i className="ri-phone-line text-xl text-[#FF6B35]"></i>
                </div>
                <div>
                  <div className="text-xs text-gray-500">Hızlı Destek</div>
                  <a href="tel:+905326018294" className="text-sm font-semibold text-[#1A2332] hover:text-[#FF6B35] transition-colors cursor-pointer">
                    +90 532 601 82 94
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-full">
                  <i className="ri-mail-line text-xl text-[#FF6B35]"></i>
                </div>
                <div>
                  <div className="text-xs text-gray-500">E-posta</div>
                  <a href="mailto:info@bioetiket.com" className="text-sm font-semibold text-[#1A2332] hover:text-[#FF6B35] transition-colors cursor-pointer">
                    info@bioetiket.com
                  </a>
                </div>
              </div>
              <div className="pt-2">
                <a
                  href="#contact"
                  className="inline-flex items-center justify-center w-full px-6 py-3 text-sm font-semibold text-white bg-[#FF6B35] rounded-full hover:bg-[#E55A2B] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Teklif Alın
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Sağ: Accordion */}
          <div className="space-y-3">
            {faqs.map((faq) => {
              const isOpen = openId === faq.id;
              return (
                <div
                  key={faq.id}
                  className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                    isOpen
                      ? 'border-[#FF6B35]/30 bg-[#FFF8F5] shadow-md'
                      : 'border-gray-100 bg-white hover:border-[#FF6B35]/20 hover:shadow-sm'
                  }`}
                >
                  <button
                    onClick={() => toggle(faq.id)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                  >
                    <span className={`text-sm font-semibold leading-snug pr-4 ${isOpen ? 'text-[#FF6B35]' : 'text-[#1A2332]'}`}>
                      {faq.question}
                    </span>
                    <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                      isOpen ? 'bg-[#FF6B35] text-white rotate-45' : 'bg-gray-100 text-gray-500'
                    }`}>
                      <i className="ri-add-line text-lg"></i>
                    </div>
                  </button>

                  <div
                    className={`transition-all duration-300 ease-in-out ${
                      isOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'
                    } overflow-hidden`}
                  >
                    <p className="px-6 pb-5 text-sm text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Schema.org FAQPage Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map(faq => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer
              }
            }))
          })
        }}
      />
    </section>
  );
}